export default {
      id: "dots-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#dots",
      toString: function () {
        return this.url;
      }
    }